import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { Paperclip } from 'react-feather';
import { apiHost } from '../api';
import { AssistantEntry } from './types';

export const MessageAttachments = ({
  message,
}: {
  message: NonNullable<AssistantEntry['message']>;
}) => (
  <Box sx={{ minWidth: 0 }}>
    {message.attachments?.map((attachment) => (
      <Link
        key={attachment.id}
        color="text.secondary"
        variant="body2"
        underline="none"
        href={`${apiHost(
          process.env.REACT_APP_PV_ENV as string
        )}/assistant/conversations/${message.conversationId}/attachments/${
          attachment.id
        }`}
        target="_blank"
        rel="noopener noreferrer"
        title={attachment.filename}
        aria-label={`Download ${attachment.filename}`}
        sx={{
          mt: 0.5,
          display: 'flex',
          alignItems: 'center',
          lineHeight: 1.5,
          gap: 0.75,
          minWidth: 0,
          maxWidth: '100%',
          transition: 'color 150ms ease',
          '&:hover': { color: 'text.primary' },
        }}
      >
        <Paperclip
          size={12}
          aria-hidden="true"
          style={{ display: 'block', flexShrink: 0 }}
        />
        <Typography
          component="span"
          variant="inherit"
          color="inherit"
          noWrap
          sx={{ minWidth: 0 }}
        >
          {attachment.filename}
        </Typography>
        <Typography
          component="span"
          variant="inherit"
          color="inherit"
          noWrap
          sx={{ flexShrink: 0, fontSize: 12, lineHeight: 'inherit' }}
        >
          {(attachment.byteSize / 1000000).toFixed(2)} MB
        </Typography>
      </Link>
    ))}
  </Box>
);
